export default function RightSection({ pageHeading, content }) {
  return (
    <div className="Cell watermark right-section">
      <div style={{ textAlign: "left" }}>
        <div
          className="Table TableListing"
          style={{ position: "absolute", top: "0px", width: "800px" }}
        >
          {pageHeading && (
            <div className="Row">
              <div className="Cell Heading">{pageHeading}</div>
            </div>
          )}
          {content}
        </div>
      </div>
    </div>
  );
}
